import React from "react";
import { WrappedLink } from "@components/navigation";
import HeaderItemWrapper from "./HeaderItemWrapper";
import classnames from "classnames";
import { getLoginReturnUrl } from "@utils/auth";

export default function HeaderLoginButton({
	culture,
	isRegistrationButtonHidden,
	text,
}: {
	culture: string;
	isRegistrationButtonHidden: boolean;
	text: string;
}) {
	classnames;
	return (
		<HeaderItemWrapper>
			<WrappedLink
				to={getLoginReturnUrl()}
				className={classnames(
					"header__btn header__btn--login btn btn--sml",
					{
						"btn--primary": isRegistrationButtonHidden,
						"btn--secondary--inverted": !isRegistrationButtonHidden,
					}
				)}
			>
				{text}
			</WrappedLink>
		</HeaderItemWrapper>
	);
}
